module.exports = __webpack_public_path__ + "img/ch18.5ebd2b97.jpg";